// extracted by mini-css-extract-plugin
export default {"title":"Caa-z","warning":"Daa-z","sizeOptionsLegendText":"Eaa-z"};